import DOMPurify from "dompurify";

export const cleanInputHtml = (dirtyHtml: string) => {
  return DOMPurify.sanitize(dirtyHtml, {
    // Permite a tag <style> global no bloco de HTML
    ADD_TAGS: ["style"],
    // Garante que o atributo style inline seja mantido em outras tags
    ADD_ATTR: ["style"],
    // Força o DOMPurify a validar o CSS dentro dos atributos style
    FORCE_BODY: true,
    // Remove o atributo HREF de qualquer tag (impede links clicáveis)
    FORBID_ATTR: ["href", "action", "formaction"],
  });
};
